/*
 * Ported verbatim from the legacy app's scripts/app/components/blazy.js.
 * Relies on the global `jQuery` shim and the `Blazy` global set up in main.js.
 */
;(function ($) {


    $(function () {
        setTimeout(function () {
            var bLazy = new window.Blazy({
                selector: '.b-image-wrapper img'
            });
        }, 50);
    });


})(window.jQuery);
